module.exports = __webpack_public_path__ + "static/img/ubud-1.cc82b75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/ubud-1.jpg
// module id = j1dG
// module chunks = 1